<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="practice bg_gray">
			<div class="w1200 flex">
				<div class="test_l bg_white">
					<div class="news_cont_l_title cl_white">
						<h3 class="f20px">试卷</h3>
						<p class="mat5">TEST PAPER</p>
					</div>
					<div class="test_l_cont f20px cl_dark">
						<div class="test_l_list mab20" v-for="(item,index) in testNav" :key="index" :class="{'on':testNavCur==item}" @click="navCheck(item)">
							<span>{{item}}</span>
						</div>
					</div>
				</div>
				<div class="test_r bg_white radius8">
					<div class="test_screen_cont">
						<div class="test_screen cl_gray">
							<div class="test_screen_l f16px"><span class="inline">学科</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectName==subjectCur}" @click="subjectCheck(item.subjectName)">{{item.subjectName}}</span>
							</div>
						</div>
						<div class="test_screen cl_gray">
							<div class="test_screen_l f16px"><span class="inline">年级</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray" v-for="(item,index) in material" :key="index" :class="{'on':item==materialCur}" @click="materialCheck(item)">{{item}}</span>
							</div>
						</div>
						<div class="test_screen cl_gray">
							<div class="test_screen_l f16px"><span class="inline">地区</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray" v-for="(item,index) in province" :key="index" :class="{'on':item.name==provinceCur}" @click="provinceCheck(item.name)">{{item.name}}</span>
							</div>
						</div>
						<div class="test_screen cl_gray">
							<div class="test_screen_l f16px"><span class="inline">试卷学年</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray" v-for="(item,index) in year" :key="index" :class="{'on':item==yearCur}" @click="yearCheck(item)">{{item}}</span>
							</div>
						</div>
					</div>
					<div class="new_test_cont mat20 flex mat10">
						<div class="new_test_list radius8 mab20" v-for="item in newTest" :key="item.id">
							<div class="new_test_list_show">
								<div class="new_test_list_top flex">
									<h3 class="f18px">{{item.paperName}}</h3>
									<p class="f16px cl_violet">{{item.number}}题</p>
								</div>
								<div class="new_test_list_btm cl_gray">
									<!-- <p class="flex mar10"><img src="../../../static/icon_time.png" class="mar5" /><span>更新于{{item.add_time}}</span></p> -->
									<p class="flex mal10"><img src="../../../static/icon_person.png" class="mar5" /><span>{{item.read_count==null? '0':item.read_count}}</span></p>
								</div>
							</div>
							<div class="new_test_list_hide radius8">
								<router-link :to="{ path: '/practice_test', query: { id: item.id }}" class="f12px cl_white flex"><img src="../../../static/icon_practice.png" class="mar5" /><span>开始练习</span></router-link>
							</div>
						</div>
					</div>
					<div class="famous_page flex" v-if="newTest.length > 0">
						<div class="famous_page_l f16px cl_gray">共 {{total}} 条记录 页次：{{currentPage}}/{{Math.ceil(total/pageSize)}}页   {{pageSize}}条/页</div>
						<div class="famous_page_r cl_dark">
							<el-pagination background layout="prev, pager, next, jumper" @size-change="handleSizeChange" 
							@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
						</div>
					</div>
					<div class="choice_empty tc f18px cl_gray" v-if="newTest.length == 0">
						<p>找不到内容，请重新选择</p>
					</div>
				</div>
			</div>
		</div>
		
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'test_list',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 2,
				myInfo: {},
				public: {},
				testNavCur: "",
				testNav: [],
				subjectCur: "",
				subject: [],
				materialCur: "",
				material: [],
				provinceCur: "",
				province: [],
				yearCur: "",
				year: [],
				newTest: [],
				currentPage: 1, //当前页数
				pageSize: 10, //每页数量
				total: 0, //总页数
			}
		},
		mounted() {
			this.getType();
			this.getSubject();
			this.getGrade();
			this.getProvince();
			this.getDate();
			this.getPaper();
		},
		created() {
			this.testNavCur = this.$route.query.type;
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//类型
			getType () {
				this.$get("/api/funlearning/get_paper_type_data",{})
				.then(res => {
					this.testNav = res.data;
				});
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
				});
			},
			//年级
			getGrade () {
				this.$get("/api/funlearning/get_grade_data",{
					parse_name: localStorage.getItem("pharseName")
				})
				.then(res => {
					this.material = res.data;
				});
			},
			//省份
			getProvince () {
				this.$get("/api/careerbible/get_province_data",{})
				.then(res => {
					this.province = res.data;
				});
			},
			//年份
			getDate () {
				var year = new Date().getFullYear();
				for (let i = 0; i < 4; i++ ) {
					this.year.push(year-(3-i))
				}
			},
			//试卷
			getPaper () {
				this.$get("/api/funlearning/get_papers_list",{
					token: localStorage.getItem("token"),
					parse_name: localStorage.getItem("pharseName"),
					subject_name: this.subjectCur,
					grade_name: this.materialCur,
					area: this.provinceCur,
					paper_type: this.testNavCur,
					year: this.yearCur,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.newTest = res.data.data;
					this.total = res.data.total;
				});
			},
			navCheck (e) {
				this.testNavCur = e;
				this.currentPage = 1;
				this.getPaper();
			},
			subjectCheck (e) {
				this.subjectCur = e;
				this.currentPage = 1;
				this.getPaper();
			},
			materialCheck (e) {
				this.materialCur = e;
				this.currentPage = 1;
				this.getPaper();
			},
			provinceCheck (e) {
				this.provinceCur = e;
				this.currentPage = 1;
				this.getPaper();
			},
			yearCheck (e) {
				this.yearCur = e;
				this.currentPage = 1;
				this.getPaper();
			},
			
			handleSizeChange: function (size) {
				this.pageSize = size;
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getPaper();
			},
		},
	}
</script>

<style>
</style>
